module.exports = __webpack_public_path__ + "static/img/app_icon.84d92d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app_icon.png
// module id = SmC9
// module chunks = 1